module.exports = __webpack_public_path__ + "images/default.svg?784ad8e0b646dc9f2e5e4b4962d22292";